export const delayDifferenceThreshold = 60;
